// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__15W7o","table":"Market_table__1YRnf","row":"Market_row__g8uf3","col":"Market_col__NAXGG","foot":"Market_foot__1tDzn","arrow":"Market_arrow__2TcPN"};